export default "__VITE_ASSET__DSo89ac8__"